import * as React from "react";
import { Link } from "react-router-dom";
import app from "../../core/application";
import * as Constants from "../../core/constants";
import { ITranslationProps, translateComponent } from "../../helpers/translation";
import IUserSearchResult from "../../types/IUserSearchResult";

interface IUserRowProps extends ITranslationProps, IUserSearchResult {
}

class UserRow extends React.Component<IUserRowProps> {
    constructor(props: IUserRowProps) {
        super(props);
    }

    public render() {
        let userLink = <div>{this.props.lastName}, {this.props.firstName}</div>;
        if (app().userHasPermission(Constants.PERMISSION_EDITUSERS)) {
            userLink = <Link to={`/user/${this.props.id}`}>{userLink}</Link>;
        }
        
        return (
            <tr>
                <td>{userLink}</td>
                <td>{this.props.email}</td>
                <td>{this.props.isActive ? this.props.t("Global.Active") : this.props.t("Global.Inactive")}</td>
            </tr>
        );
    }
}

export default translateComponent(UserRow);



// WEBPACK FOOTER //
// ./src/components/UserList/UserRow.tsx